// extracted by mini-css-extract-plugin
module.exports = {"ReactLogo":"ReactLogo_ReactLogo__1GfjX","ReactLogo-spin":"ReactLogo_ReactLogo-spin__1iC6g"};